export const LOGIN_PATH = "/login";

// Адрес страницы входа с возвратом на текущую страницу: `/login?next=%2Fmatches%2F42`.
export const buildLoginUrl = (location: Pick<Location, "pathname" | "search" | "hash">): string => {
  const next = `${location.pathname}${location.search}${location.hash}`;
  return `${LOGIN_PATH}?${new URLSearchParams({ next }).toString()}`;
};

// Обработчик 401 по умолчанию: полный переход на `/login?next=…`.
// Перезагрузка страницы заодно сбрасывает весь кэш Query и подключение Centrifugo.
// На самой странице входа ничего не делает: там 401 от `GET /api/me` — обычное дело.
export const redirectToLogin = (
  navigate: (url: string) => void = (url) => {
    window.location.assign(url);
  },
): void => {
  if (window.location.pathname === LOGIN_PATH) {
    return;
  }
  navigate(buildLoginUrl(window.location));
};
